"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var R = _interopRequireWildcard(require("ramda"));
var _checkbox = _interopRequireDefault(require("../../checkbox"));
var _label = _interopRequireDefault(require("../../label"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var FilterCollapseItem = function FilterCollapseItem(_ref) {
  var item = _ref.item,
    selectedItems = _ref.selectedItems,
    virtualized = _ref.virtualized,
    _onChange = _ref.onChange,
    subItem = _ref.subItem,
    style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("li", {
    key: "".concat(item.title).concat(subItem.value),
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_checkbox["default"], {
    id: "".concat(item.title, "_").concat(subItem.value),
    checked: R.find(function (element) {
      return element === subItem.value;
    }, R.prop(item.key, selectedItems) || []) || false,
    onChange: function onChange(event, value) {
      return _onChange(event, item, subItem, value);
    }
  }), /*#__PURE__*/_react["default"].createElement(_label["default"], {
    htmlFor: "".concat(item.title, "_").concat(subItem.value),
    className: virtualized ? 'item-text-label' : ''
  }, /*#__PURE__*/_react["default"].createElement("span", null, subItem.value), " (", /*#__PURE__*/_react["default"].createElement("strong", null, subItem.count), ")"));
};
FilterCollapseItem.propTypes = {
  item: _propTypes["default"].shape({
    title: _propTypes["default"].string,
    key: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
  }).isRequired,
  subItem: _propTypes["default"].shape({
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    count: _propTypes["default"].number
  }).isRequired,
  selectedItems: _propTypes["default"].shape({}),
  virtualized: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  style: _propTypes["default"].shape({})
};
FilterCollapseItem.defaultProps = {
  selectedItems: {},
  virtualized: false,
  onChange: _utils.noop,
  style: null
};
FilterCollapseItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FilterCollapseItem",
  "props": {
    "selectedItems": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "virtualized": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "noop",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "style": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "item": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "title": {
            "name": "string",
            "required": false
          },
          "key": {
            "name": "union",
            "value": [{
              "name": "string"
            }, {
              "name": "number"
            }],
            "required": false
          }
        }
      },
      "required": true
    },
    "subItem": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "value": {
            "name": "union",
            "value": [{
              "name": "string"
            }, {
              "name": "number"
            }],
            "required": false
          },
          "count": {
            "name": "number",
            "required": false
          }
        }
      },
      "required": true
    }
  }
};
var _default = FilterCollapseItem;
exports["default"] = _default;